/* eslint-disable @typescript-eslint/no-non-null-assertion */
export var UploadManagerEvent;
(function (UploadManagerEvent) {
    UploadManagerEvent["FileStarted"] = "fileStarted";
    UploadManagerEvent["FileFinished"] = "fileFinished";
    UploadManagerEvent["FileProgress"] = "fileProgress";
    UploadManagerEvent["QueueStarted"] = "queueStarted";
    UploadManagerEvent["QueueFinished"] = "queueFinished";
    UploadManagerEvent["QueueProgress"] = "queueProgress";
})(UploadManagerEvent || (UploadManagerEvent = {}));
export default class UploadManager {
    eventHandlers;
    uploadQueue = new Set();
    constructor() {
        this.eventHandlers = new Map([
            [UploadManagerEvent.FileFinished, new Set()],
            [UploadManagerEvent.FileProgress, new Set()],
            [UploadManagerEvent.FileStarted, new Set()],
            [UploadManagerEvent.QueueFinished, new Set()],
            [UploadManagerEvent.QueueProgress, new Set()],
            [UploadManagerEvent.QueueStarted, new Set()],
        ]);
    }
    addFileStartedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileStarted).add(handler);
        return handler;
    }
    removeFileStartedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileStarted).delete(handler);
    }
    dispatchFileStarted(file) {
        const handlers = this.eventHandlers.get(UploadManagerEvent.FileStarted);
        handlers.forEach((handler) => {
            handler(file);
        });
    }
    addFileFinishedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileFinished).add(handler);
        return handler;
    }
    removeFileFinishedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileFinished).delete(handler);
    }
    dispatchFileFinished(file, error) {
        const handlers = this.eventHandlers.get(UploadManagerEvent.FileFinished);
        handlers.forEach((handler) => {
            handler(file, error);
        });
    }
    addFileProgressHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileProgress).add(handler);
        return handler;
    }
    removeFileProgressHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.FileProgress).delete(handler);
    }
    dispatchFileProgress(file, sentBytes, totalBytes) {
        const handlers = this.eventHandlers.get(UploadManagerEvent.FileProgress);
        handlers.forEach((handler) => {
            handler(file, sentBytes, totalBytes);
        });
    }
    addQueueStartedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueStarted).add(handler);
        return handler;
    }
    removeQueueStartedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueStarted).delete(handler);
    }
    dispatchQueueStarted() {
        const handlers = this.eventHandlers.get(UploadManagerEvent.QueueStarted);
        handlers.forEach((handler) => {
            handler();
        });
    }
    addQueueFinishedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueFinished).add(handler);
        return handler;
    }
    removeQueueFinishedHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueFinished).delete(handler);
    }
    dispatchQueueFinished(err) {
        const handlers = this.eventHandlers.get(UploadManagerEvent.QueueFinished);
        handlers.forEach((handler) => {
            handler(err);
        });
    }
    addQueueProgressHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueProgress).add(handler);
        return handler;
    }
    removeQueueProgressHandler(handler) {
        this.eventHandlers.get(UploadManagerEvent.QueueProgress).delete(handler);
    }
    dispatchQueueProgress(processed, queueLength) {
        const handlers = this.eventHandlers.get(UploadManagerEvent.QueueProgress);
        handlers.forEach((handler) => {
            handler(processed, queueLength);
        });
    }
    queueUpload(file) {
        this.uploadQueue.add(file);
    }
    dequeueUpload(file) {
        this.uploadQueue.delete(file);
    }
    queueUploads(files) {
        for (const file of files) {
            this.queueUpload(file);
        }
    }
    dequeueUploads(files) {
        for (const file of files) {
            this.dequeueUpload(file);
        }
    }
    clearQueue() {
        this.uploadQueue.clear();
    }
    getQueue() {
        return this.uploadQueue;
    }
    async uploadNextInQueue(filesToUpload, totalQueueLength) {
        if (filesToUpload.length > 0) {
            const file = filesToUpload.shift();
            if (file) {
                this.dispatchFileStarted(file);
                try {
                    file.uploadedUrl = await this.upload(file);
                }
                catch (err) {
                    this.dispatchFileFinished(file, err);
                    throw err;
                }
                this.uploadQueue.delete(file);
                this.dispatchFileFinished(file);
                this.dispatchQueueProgress(totalQueueLength - filesToUpload.length, totalQueueLength);
            }
        }
    }
    async uploadAllInQueue() {
        this.dispatchQueueStarted();
        const files = Array.from(this.uploadQueue);
        try {
            await this.uploadNextInQueue(files, files.length);
            this.dispatchQueueFinished();
        }
        catch (err) {
            this.dispatchQueueFinished(err);
            throw err;
        }
    }
}
//# sourceMappingURL=UploadManager.js.map